module.exports = __webpack_public_path__ + "img/21-avatar male.8dd22a67.png";